import CIcon from "@coreui/icons-react";
import { CForm } from "@coreui/react";
import React from "react";
import { useForm } from "react-hook-form";
import { BasicSelect, SquareButtonOutline } from "src/components";
import { useResizeObserver } from "src/hooks";

const VersionPanel = ({
  title,
  options,
  currentVersionId,
  onSwitch,
  onAdd,
  color,
  switchBtnLabel,
  addBtnLabel,
}) => {
  const methods = useForm();

  const { width } = useResizeObserver();
  const isMobile = width <= 768;

  //   console.log("currentVersionId :>> ", currentVersionId);

  if (!currentVersionId) return null;

  const {
    setValue,
    formState: { touchedFields },
    handleSubmit,
  } = methods;

  const handleSelect = (e) => {
    setValue("version", e.target.value, { shouldTouch: true });
  };

  const onSubmit = (data) => {
    const { version } = data;
    if (!version) return;
    if (version === currentVersionId) return;
    onSwitch(version);
  };

  const currentVersion = options?.find((v) => v.value === currentVersionId);

  return (
    <>
      <p style={{ fontSize: 20 }}>
        {title}
        <span style={{ fontSize: 20 }} className={`text-${color}`}>
          {currentVersion?.label}
        </span>
      </p>

      <CForm
        className={`d-flex ${
          isMobile && "flex-column gap-3"
        } align-items-baseline`}
        onSubmit={handleSubmit(onSubmit)}
      >
        <span className="flex-shrink-0 mr-2">Available versions: </span>
        <BasicSelect
          options={options}
          onChange={handleSelect}
          defaultValue={currentVersionId}
          placeholder={"Select..."}
          className=" mr-2"
          style={{
            maxWidth: isMobile ? "300px" : "500px",
          }}
        />
        <SquareButtonOutline
          disabled={touchedFields?.version === undefined}
          className=" flex-shrink-0"
          type="submit"
          style={!isMobile ? { width: "200px" } : undefined}
          color={color}
        >
          {switchBtnLabel}
          <CIcon className="ml-1" name="cilSwapVertical" />
        </SquareButtonOutline>
      </CForm>
      <SquareButtonOutline
        onClick={onAdd}
        color={color}
        className="mt-3"
        type="button"
      >
        {addBtnLabel} <CIcon name="cil-plus" />
      </SquareButtonOutline>
    </>
  );
};

export default VersionPanel;
